<template>
  <div>
    <div class="text-h6 mb-4">Gestion des utilisateurs</div>

    <users-metrics class="mb-4"></users-metrics>
    <users-buttons></users-buttons>
    <users-table></users-table>
  </div>
</template>

<script>
import UsersTable from './Components/UsersTable'
import UsersMetrics from './Components/UsersMetrics'
import UsersButtons from '@/views/Pages/Admin/AdminUsers/Components/UsersButtons'

export default {
  name: 'AdminUsersPage',
  components: {
    UsersButtons,
    UsersMetrics,
    UsersTable,
  },
}
</script>